import {
  IBucketV2BlackoutEntry,
  IBucketV2BlackoutsList,
} from "api/entities/blackout";
import { DataService } from "./data-service";

class BlackoutService extends DataService {
  constructor() {
    super("blackouts", 2);
  }

  listBucketBlackouts(bucketId: string): Promise<IBucketV2BlackoutsList> {
    return this.api.get<IBucketV2BlackoutsList>(bucketId);
  }

  setBucketBlackout(
    bucketId: string,
    request: IBucketV2BlackoutEntry,
  ): Promise<string> {
    return this.api.post<string>(null, {
      bucketId,
      ...request,
    });
  }

  deleteBucketBlackout(bucketId: string, blackoutId: string): Promise<void> {
    return this.api.delete(`${bucketId}/${blackoutId}`);
  }
}

export const blackoutService = new BlackoutService();